var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/brands","title":"Lista marek","numeral_text":['marka', 'marki', 'marek'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }